import * as THREE from 'three';

import AbstractObject from '../misc/object';

export default class ArrowCurve extends AbstractObject {

  static types = {
    direction: {
      X: 'x',
      Y: 'y',
      Z: 'z'
    }
  };

  constructor(options) {
    super(options);

    this.color = this.options.color || 0x000000;

    const curve = new THREE.EllipseCurve(
      0, 0, // ax, aY
      this.options.size, this.options.size, // xRadius, yRadius
      0, this.options.isClockwise ? -Math.PI* 1.5 : Math.PI* 1.5, // aStartAngle, aEndAngle
      this.options.isClockwise, // aClockwise
      0 // aRotation
    );

    this.direction = this.options.direction;
    this.shift = this.options.shift;

    const points = curve.getPoints(50);
    const geometry = new THREE.BufferGeometry().setFromPoints(points);

    const material = new THREE.LineBasicMaterial({ color: this.color, linewidth: 5 });
    const line = new THREE.Line(geometry, material);

    const innerObject = new THREE.Object3D();
    innerObject.add(line);

    const coneGeometry = new THREE.ConeGeometry(4, 15, 5);
    const cone = new THREE.Mesh(coneGeometry, material);
    cone.rotation.x = this.options.isClockwise ? 0 : Math.PI;
    cone.position.x = this.options.size;
    cone.position.y = this.options.isClockwise ? 5 : -5;
    innerObject.add(cone);

    this.object = new THREE.Object3D();
    this.object.add(innerObject);

    switch (this.options.direction) {
      case ArrowCurve.types.direction.Y: {
        innerObject.rotation.x = Math.PI / -2;
        break;
      }
      case ArrowCurve.types.direction.Z: {
        innerObject.rotation.x = 0;
        break;
      }
      default: {
        innerObject.rotation.y = Math.PI / -2;
        break;
      }
    }

    if (this.options.shift) {
      this.object.add(getLine({
        color: this.color,
        size: this.shift,
        direction: this.direction,
        from: this.position
      }));

      switch (this.options.direction) {
        case ArrowCurve.types.direction.X: {
          innerObject.position.x += this.shift;
          break;
        }
        case ArrowCurve.types.direction.Y: {
          innerObject.position.y -= this.shift;
          break;
        }
        case ArrowCurve.types.direction.Z: {
          innerObject.position.z -= this.shift;
          break;
        }
        default: {
          throw new Error('Something went wrong!');
        }
      }
    }
  }

  get position () {
    let to = null;
    switch (this.direction) {
      case ArrowCurve.types.direction.X: {
        to = new THREE.Vector3(this.shift, 0, 0);
        break;
      }
      case ArrowCurve.types.direction.Y: {
        to = new THREE.Vector3(0, -this.shift, 0);
        break;
      }
      case ArrowCurve.types.direction.Z: {
        to = new THREE.Vector3(0, 0, -this.shift);
        break;
      }
      default: {
        throw new Error('Something went wrong!');
      }
    }

    return to;
  }

  get directionPosition () {
    return new THREE.Vector3(
      this.position.x + this.options.position.x, 
      this.position.y + this.options.position.y,
      this.position.z + this.options.position.z); // for labels
  }

  get mesh() {
    return this.object;
  }

}

function getLine({ color, size, direction, from }) {
  // VladP: Geometry class was removed, changed with BufferGeometry
  const lineGeometry = new THREE.BufferGeometry();
  var linePositions = [];
  linePositions.push(from.x, from.y, from.z);
  linePositions.push(0, 0, 0);
  lineGeometry.setAttribute('position', new THREE.Float32BufferAttribute(linePositions, 3));

  // VladP: Three.js version was changed and computeLineDistances was removed from geometry
  // lineGeometry.computeLineDistances(); 
  const lineMaterial = new THREE.LineDashedMaterial({ color, dashSize: 6, gapSize: 5 });

  const line = new THREE.Line(lineGeometry, lineMaterial);
  line.computeLineDistances();
  return line;
}



// WEBPACK FOOTER //
// ./src/object-view/objects/arrow-curve.js